const mapping = {
    "010000 Roundwood": {
        "010400 Wood residues": [],
        "010200 Pulpwood": [],
        "010500 Bark": [],
        "010600 Other roundwood": [],
        "010100 Sawlogs and veneer logs": [],
        "010300 Chips and particles": []
    },
    "020000 Fuelwood and energy": {
        "020200 Charcoal": [],
        "020100 Fuelwood": [],
        "020300 Pellets and brickets": []
    },
    "030000 Sawnwood and treated wood": {
        "030100 Sawnwood": [
            "030101 Flitches, boules and slabs",
            "030102 Solid wood boards and planks",
            "030103 Beams",
            "030104 Poles and piles",
            "030105 Peeler cores",
            "030106 Pencil slat",
            "030107 Other sawnwood"
        ],
        "030200 Railway sleepers / ties": [],
        "030300 Impregnated or treated wood": []
    },
    "040000 Engineered wood products": {
        "040100 Cross Laminated Timber (CLT)": [],
        "040200 Finger Jointed Lumber": [],
        "040400 Laminated Veneer Lumber (LVL)": [],
        "040300 Glue Laminated Products (Glulam)": [],
        "041000 Other engineered wood products": [],
        "040500 Parallel Strand Lumber (PSL)": [],
        "040600 I-Joists / I-Beams": [],
        "040700 Trusses & Engineered Panels": [],
        "040800 Scantlings": [],
        "040900 Composite board": []
    },
    "050000 Wood based panels": {
        "050600 Fibreboard": [
            "050602 High Density Fiberboard (HDF)",
            "050601 Medium Density Fiberboard (MDF)",
            "050603 Softboard and insulating board"
        ],
        "050500 Particle board": [
            "050501 Chipboard",
            "050502 OSB",
            "050503 Other particle board"
        ],
        "050100 Veneer sheets": [],
        "050200 Plywood": [],
        "040500 Parallel Strand Lumber (PSL)": [],
        "050700 Cement board": [],
        "050800 Other wood based panels": [],
        "050300 Blockboard": [],
        "050400 Panels for transportation": []
    },
    "060000 Wood manufacturers": {
        "060200 Household goods": [
            "060201 Wooden frames",
            "060203 Kitchenware and similar utensils",
            "060204 Hangers and clothes pegs",
            "060209 Other household products",
            "060206 Bathroom accessories"
        ],
        "060300 Tools and turned wood": [
            "060310 Other tools and turned wood",
            "060302 Toys and games",
            "060307 Decorative objects and art",
            "060305 Wooden stationery",
            "060306 Dowels",
            "060303 Sport goods"
        ],
        "060400 Other manufactured wood": [
            "060402 Others"
        ],
        "060100 Wood packaging": [
            "060104 Barrels, staves and other cooperage products"
        ]
    },
    "070000 Indoor Furniture": {
        "070100 Tables": [],
        "070200 Chairs and stools": [],
        "070400 Benches": [],
        "070500 Bedroom Furniture": [],
        "070600 Storage systems and units": [],
        "070700 Kitchen units and worktops": [],
        "070800 Office furniture": [],
        "070900 Educational / Institutional furniture": [],
        "071100 Childrens Furniture": [],
        "071200 Custom Furniture": [],
        "071300 Furniture components": [],
        "071400 Other furniture": [],
        "070300 Sofas and armchairs": []
    },
    "080000 Exterior products": {
        "080100 Garden Furniture / Outdoor Products": [
            "080103 Decking and garden sleepers",
            "080101 Garden furniture"
        ],
        "080200 Landscaping Timbers": [
            "080203 Fencing material",
            "080202 Trellis and plant support",
            "080201 Garden sheds",
            "080205 Garden storage",
            "080204 Pergolas"
        ],
        "080400 Other exterior products": []
    },
    "090000 Wooden Buildings and construction material": {
        "090300 Wood material for construction": [
            "090307 Other wood material for construction",
            "090305 Architectural joinery items",
            "090302 Doors",
            "090301 Windows",
            "090303 Shingles and shakes",
            "090304 Flooring"
        ],
        "090100 General Wooden Buildings and constructions": [],
        "090200 Integrated Parts of Wooden Buildings and constructions": [
            "090201 Exterior",
            "090206 Interior",
            "090202 Structure",
            "090203 Roof",
            "090204 Wall"
        ]
    },
    "100000 Pulp": {
        "100400 Chemical pulp": [
            "100403 Unbleached sulphate (kraft) pulp",
            "100404 Bleached sulphate (kraft) pulp"
        ],
        "100300 Dissolving pulp and derivatives": [
            "100301 cellulosic fibre from dissolving pulp"
        ]
    },
    "110000 Paper and paper board": {
        "110100 Graphic papers": [
            "110107 Other graphic papers",
            "110104 Woodfree papers (coated and uncoated)",
            "110102 Uncoated mechanical papers",
            "110101 Newsprint paper",
            "110103 Coated mechanical papers",
            "110105 Paper for blank forms",
            "110106 Paper for tickets"
        ],
        "110400 Packaging materials": [
            "110407 Flexible paper packaging",
            "110404 Sacks and Paper bags",
            "110403 Wrapping papers",
            "110401 Case materials and corrugated and Solid Fiber Box",
            "110402 Cartonboard, Folding boxboards",
            "110405 Food and beverages packaging",
            "110411 Other papers mainly for packaging",
            "110408 Paper trays, containers, cups"
        ],
        "110200 Printed matter": [
            "110201 Books",
            "110202 Book covers",
            "110203 Magazines and Newspaper",
            "110206 Calendars, diaries and organisers",
            "110205 Marketing collateral",
            "110208 Other printed matter",
            "110204 Paper toys and games",
            "110207 Point-of-sales materials"
        ],
        "110500 Stationery Products": [
            "110501 Notebooks",
            "110504 Rolled thermal paper",
            "110508 Adhesive labels",
            "110506 Envelopes"
        ],
        "110300 Household and sanitary paper": [
            "110307 Sanitary products",
            "110309 Wet wipes",
            "110302 Toilet paper / bathroom tissue",
            "110301 Tissues products",
            "110304 Kitchen paper",
            "110305 Tablecloths and napkins",
            "110306 Paper dinnerware",
            "110310 Other household and sanitary paper"
        ],
        "110600 Other paper and paperboard": [
            "110605 Impregnated paper"
        ],
        "110700 Other converted paper products": []
    },
    "120000 Non-wood products": {
        "120200 Rubber / Latex": [
            "120203 Foam"
        ],
        "120900 Other non-wood products": [],
        "120100 Cork and cork products": [
            "120104 Rolls and panels of compressed cork",
            "120106 Cork for construction"
        ]
    },
    "130000 Other products": {},
    "N1 Barks": {},
    "N10 Other NTFP n.e.c": {},
    "N2 Soil conditioner and substrates": {},
    "N2 Soil conditioner and substrates for plants": {},
    "N3 Cork and articles of cork": {
        "N3.1 Natural cork, raw or boiled": [],
        "N3.2 Cork powder": [],
        "N3.3 Cork granules": [],
        "N3.4 Cork stoppers": [],
        "N3.5 Rolls and panels of compressed cork": [],
        "N3.6 Cork disks": [],
        "N3.7 Articles of cork": []
    },
    "N4 Straw, wicker, rattan and similar": {
        "N4.1 Rattan cane (rough form)": [],
        "N4.2 Rattan taper (clean, peeled etc)": [],
        "N4.3 Decorative objects and wickerwork": [],
        "N4.4 Rattan furniture": [],
        "N4.5 Rattan furniture components": []
    },
    "N5 Bamboo and articles of bamboo": {
        "N5.1 Natural bamboo": [],
        "N5.2 Edible bamboo": [],
        "N5.3 Fuel bamboo": [],
        "N5.4 Bamboo plywood": [],
        "N5.5 Bamboo flooring": [],
        "N5.6 Bamboo furniture": [],
        "N5.7 Bamboo household articles and wickerwork": [],
        "N5.8 Bamboo textiles": [],
        "N5.9 Bamboo vinegar": [],
        "N5.10 Bamboo pulp": [],
        "N5.7 Bamboo home articles, wickerwork": []
    },
    "N6 Plants and parts of plants": {
        "N6.1 Flowers": [],
        "N6.2 Grasses, ferns, mosses and lichens": [],
        "N6.3 Whole trees or plants": [
            "N6.3.1 Christmas trees"
        ],
        "N6.4 Pine cones": [],
        "N6.3 Wholetreesor plants": [
            "N6.3.1 Christmas trees"
        ]
    },
    "N7 Natural gums, oils and derivatives": {
        "N7.1 Rubber/ Latex": [
            "N7.1.7 Other manufactured rubber prods.",
            "N7.1.1 Natural rubber",
            "N7.1.5 Rubber foam pillows, mattresses",
            "N7.1.3 Balls"
        ],
        "N7.2 Gum resin": [],
        "N7.3 Resin and manufactured products": [],
        "N7.5 Essential oils": []
    },
    "N7 Natural gums, resins, oils and derivatives": {
        "N7.1 Rubber/ Latex": [
            "N7.1.4 Footwear",
            "N7.1.1 Natural rubber",
            "N7.1.2 Tyres",
            "N7.1.3 Balls",
            "N7.1.5 Rubber foam pillows and mattresses",
            "N7.1.6 Balata, gutta-percha, guayule, chicle",
            "N7.1.7 Other manufactured articles of rubber"
        ],
        "N7.2 Gum resin": [],
        "N7.3 Resin and manufactured resin products": [],
        "N7.4 Tannin": [],
        "N7.5 Essential oils": []
    },
    "N8 Chemical, medicinal and cosmetic": {
        "N8.4 Cosmetics and health care products": []
    },
    "N8 Chemical, medicinal and cosmetic products": {
        "N8.1 Ethanol": [],
        "N8.2 Medicinal plants and products": [],
        "N8.3 Pharmaceutical raw materials": [],
        "N8.4 Cosmetics and health care products": [],
        "N8.5 Wood vinegar": [],
        "N8.6 Pyroligneous acid": []
    },
    "N9 Food": {
        "N9.1 Nuts": [],
        "N9.2 Tea": [],
        "N9.3 Palm-hearts": [],
        "N9.4 Mushrooms, truffles": [],
        "N9.5 Fruits": [],
        "N9.6 Sap-based foods": [
            "N9.6.1 Maple syrup or sugar",
            "N9.6.2 Birch syrup or sugar"
        ],
        "N9.7 Game": [],
        "N9.8 Honey": []
    },
    "Not Applicable": {},
    "P1 Pulp": {
        "P1.1 Mechanical pulp, bleached": [
            "P1.1.1 Groundwood",
            "P1.1.2 Refiner pulp"
        ],
        "P1.2 Mechanical pulp, unbleached": [
            "P1.2.1 Groundwood",
            "P1.2.2 Refiner pulp"
        ],
        "P1.3 Chemical pulp, bleached": [],
        "P1.4 Chemical pulp, unbleached": [],
        "P1.5 Semi-chemical pulp, bleached": [],
        "P1.6 Semi-chemical pulp, unbleached": [],
        "P1.7 Dissolving pulp": [
            "P1.7.1 Specialty cellulose",
            "P1.7.2 Cellulose derivatives",
            "P1.7.3 Regenerated cellulose film",
            "P1.7.4 Rayon and other synthetic fibres"
        ],
        "P1.8 Pulp from recovered paper": [
            "P1.8.1 Recovered pulp, deinked",
            "P1.8.2 Recovered pulp, not deinked"
        ]
    },
    "P10 Other pulp and paper products n.e.c.": {},
    "P10 Other pulp and paper products n.e.c.*": {},
    "P2 Paper": {
        "P2.1 Copying, printing, communication paper": [
            "P2.1.1 Coated paper",
            "P2.1.2 Uncoated paper"
        ],
        "P2.2 Copying, printing, communication paper": [],
        "P2.3 Wrapping and packaging paper": [],
        "P2.4 Specialty paper": [
            "P2.4.1 Impregnated papers",
            "P2.4.2 Photographic base papers",
            "P2.4.3 Thermographic papers",
            "P2.4.4 Translucent papers",
            "P2.4.5 Self-copying and carbon papers",
            "P2.4.6 Cigarette papers",
            "P2.4.7 Filter papers",
            "P2.4.8 Crepe papers",
            "P2.4.9 Embossed paper and perforated paper",
            "P2.4.10 Composite papers",
            "P2.4.11 Wallpaper base",
            "P2.4.12 Security paper",
            "P2.4.9 Embossed and perforated paper"
        ],
        "P2.5 Hand-made papers": [],
        "P2.6 Tissue paper": [],
        "P2.2 Newsprint": []
    },
    "P3 Paperboard": {
        "P3.1 Uncoated paperboard": [],
        "P3.2 Coated paperboard": [],
        "P3.3 Pressboard": [],
        "P3.4 Paperboardlaminates": [
            "P3.4.1 High-pressure laminates",
            "P3.4.2 Low-pressure laminates (LPL)",
            "P3.4.3 Continuous pressure laminates (CPL)",
            "P3.4.2 Low-pressure laminates",
            "P3.4.3 Continuous pressure laminates"
        ],
        "P3.5 Metalized paperboard": [],
        "P3.6 Crepe paperboard": []
    },
    "P4 Corrugated paper and paperboard": {
        "P4.1 Linerboard or testliner": [],
        "P4.2 Fluting": [],
        "P4.3 Corrugated fibreboard": []
    },
    "P5 Packaging and wrappings of paper": {
        "P5.1 Cardboard packaging": [],
        "P5.3 Sacks and bags of paper": [],
        "P5.2 Corrugated paper packaging": [],
        "P5.4 Food wrapping paper": [],
        "P5.5 Carton pack for beverages and liquid food": [],
        "P5.6 Egg boxes and similar": [],
        "P5.7 Optical disc packaging and covers": [],
        "P5.5 Carton packfor beverages and liquidfood": []
    },
    "P6 Household and sanitary products": {
        "P6.1 Cleaning tissues and paper towels": [],
        "P6.3 Napkins / serviettes": [],
        "P6.4 Toilet paper / bathroom tissue": [],
        "P6.5 Sanitary towels, tampons, diapers and similar": [],
        "P6.7 Dinnerware": [],
        "P6.2 Facial tissues and refreshing tissues": [],
        "P6.6 Tablecloths": [],
        "P6.8 Medical supplies made of pulp/paper": []
    },
    "P6 Household and sanitary pulp and paper products": {
        "P6.1 Cleaning tissues and paper towels": [],
        "P6.2 Facial tissues and refreshing tissues": [],
        "P6.3 Napkins / serviettes": [],
        "P6.4 Toilet paper / bathroom tissue": [],
        "P6.5 Sanitary towels, tampons, diapers and similar": [],
        "P6.6 Tablecloths": [],
        "P6.7 Dinnerware": [],
        "P6.8 Medical supplies made of pulp/paper": []
    },
    "P7 Stationery of paper": {
        "P7.1 Notebooks": [],
        "P7.3 File folders": [],
        "P7.2 Pads": [],
        "P7.4 Rolled thermal paper": [],
        "P7.6 Envelopes": [],
        "P7.7 Gummed papers": [],
        "P7.8 Adhesive labels": [],
        "P7.9 Transfers": [],
        "P7.10 Postage stamps": [],
        "P7.5 Post and greeting cards": []
    },
    "P8 Printed materials": {
        "P8.6 Calendars, diaries and organisers": [],
        "P8.4 Advertising materials": [],
        "P8.7 Toys and games made with paper": [],
        "P8.8 Wallpapers": [],
        "P8.2 Magazines": [],
        "P8.1 Books": [],
        "P8.3 Newspaper": [],
        "P8.5 Business cards": [],
        "P7.5 Post and greeting cards": []
    },
    "P9 Bobbins, spools, rolls and similar": {},
    "W1 Rough wood": {
        "W1.1 Roundwood (logs)": ["W4.3.1 Treated glued laminated timper"],
        "W1.2 Fuel wood": [],
        "W1.3 Twigs": []
    },
    "W10 Wood package and similar": {
        "W10.1 Solid wood packaging": [],
        "W10.2 Cable-drums": [],
        "W10.3 Pallets and skids": [],
        "W10.4 Cooper's products": [],
        "W10.5 Container flooring": []
    },
    "W11 Wood for construction": {
        "W11.1 Doors and door frames": [],
        "W11.2 Windows and window frames": [],
        "W11.3 Stairs": [],
        "W11.4 Dividers": [],
        "W11.5 Flooring": [
            "W11.5.1 Laminate flooring",
            "W11.5.2 Parquet flooring",
            "W11.5.3 Plank flooring",
            "W11.5.4 Wood-block flooring",
            "W11.5.5 Engineered flooring"
        ],
        "W11.6 Gates and garage doors": [],
        "W11.7 Wall cladding": [],
        "W11.8 Mouldings": [],
        "W11.9 Hot tubs and sauna": [],
        "W11.10 Wooden insulation": [],
        "W11.11 Window blinds, shutters etc": [],
        "W11.12 Houses and building elements": [],
        "W11.13 Marine constructions, excl. boats": [],
        "W11.14 Trusses and roofs": [],
        "W11.15 Roofing tiles": []
    },
    "W12 Indoor furniture": {
        "W12.1 Cabinet": [],
        "W12.2 Custom Furniture": [],
        "W12.3 Tables": [],
        "W12.4 Beds": [],
        "W12.5 Couches and armchairs": [],
        "W12.6 Chairs and stools": [],
        "W12.7 Office furniture": [],
        "W12.8 Institutional casework": [],
        "W12.9 Wardrobes": [],
        "W12.10 Cupboards and chests": [],
        "W12.11 Kitchen countertops": [],
        "W12.12 Parts of furniture": [],
        "W12.13 Shelves": []
    },
    "W13 Outdoor furniture and gardening": {
        "W13.1 Garden furniture": [
            "W13.1.1 Garden tables",
            "W13.1.2 Gardenbenches",
            "W13.1.3 Garden chairs and stools",
            "W13.1.4 Hammocks and hammock frames"
        ],
        "W13.2 Trellis and plant support": [],
        "W13.3 Shelters and parasols": [],
        "W13.4 Fences, fence stakes, pales": [],
        "W13.5 Decking and garden sleepers": [],
        "W13.6 Garden sheds": [],
        "W13.7 Other furniture and garden prod.": []
    },
    "W14 Musical instruments": {
        "W14.1 String musical instruments": [],
        "W14.2 Keyboard musical instruments": [],
        "W14.3 Wind or mouth-blown musical instruments": [],
        "W14.4 Percussion instruments": [],
        "W14.5 Parts of musical instruments": [],
        "W14.4 Percussions": [],
        "W14.3 Wind or mouth-blown instruments": []
    },
    "W15 Recreational goods": {
        "W15.1 Playground equipment": [],
        "W15.2 Toys and games made with wood": [],
        "W15.3 Sporting goods": [
            "W15.3.1 Bicycles",
            "W15.3.2 Bats, sticks, poles and paddles",
            "W15.3.3 Boards and skis",
            "W15.3.4 Other sporting goods"
        ]
    },
    "W16 Household articles": {
        "W16.1 Wooden frames": [],
        "W16.2 Wooden frames": [],
        "W16.3 Tableware, kitchenware and similar": [],
        "W16.4 Clothes hangers and pegs": [],
        "W16.5 Toilet seats": [],
        "W16.6 Matches": [],
        "W16.7 Mousetraps": [],
        "W16.8 Fans": [],
        "W16.9 Ladders": [],
        "W16.10 Bath items or accessories": [],
        "W16.2 Brooms, brushes and brush handles": []
    },
    "W17 Stationery of wood": {
        "W17.1 Pens": [],
        "W17.2 Pencils": [],
        "W17.3 Rulers": [],
        "W17.4 Stamps": []
    },
    "W18 Other manufactured wood products": {
        "W18.1 Dowels and turnery parts of wood": [],
        "W18.2 Coffins": [],
        "W18.3 Medical supplies made of wood": [],
        "W18.4 Tools, tool bodies and tool handles": [],
        "W18.5 Icepop/lollysticks": [],
        "W18.6 Jewellery": [],
        "W18.7 Works of art": [],
        "W18.8 Ornamental & decorative objects": [],
        "W18.9 Wheels": [],
        "W18.10 Boats": [],
        "W18.12 Wildlife and pet products": [],
        "W18.4 Tools, tool bodies and handles": [],
        "W18.11 Wooden lighters": []
    },
    "W19 Other wood products n.e.c.": {},
    "W2 Wood charcoal": {},
    "W3 Wood in chips or particles": {
        "W3.5 Wood flour": [],
        "W3.6 Wood pellets": [],
        "W3.7 Sawdust briquettes": [],
        "W3.1 Wood Chips": [],
        "W3.2 Sawdust": [],
        "W3.3 Wood shavings": [],
        "W3.4 Wood wool": []
    },
    "W4 Impregnated/treated wood": {
        "W4.1 Impregnated roundwood": [],
        "W4.2 Impregnated railway sleepers/ties": [],
        "W4.3 Treated dimensional lumber, plywood": [
            "W4.3.1 Treated glued laminated timper",
            "W4.3.2 Treated finger jointed lumber",
            "W4.3.1 Treated glued laminated timber"
        ]
    },
    "W5 Solid wood (sawn, chipped, peeled)": {
        "W5.1 Flitches and boules": [],
        "W5.2 Solid wood boards": [],
        "W5.3 Beams": [],
        "W5.4 Planks": [],
        "W5.5 Poles and piles": [],
        "W5.6 Railway ties, not impregnated": [],
        "W5.7 Raw wood for parquet flooring": [],
        "W5.8 Slabs and edgings": [],
        "W5.9 Pencil slats": []
    },
    "W6 Products from planing mill": {
        "W6.1 Dimensional lumber, finished": [],
        "W6.2 Non-dimensional timber and lumber": [],
        "W6.3 Boards, finished": []
    },
    "W7 Veneer": {
        "W7.1 Peeled veneer": [],
        "W7.2 Sliced veneer": [],
        "W7.3 Sawn veneer": [],
        "W7.4 Veneer strips": []
    },
    "W8 Wood panels": {
        "W8.1 Plywood": [
            "W8.1.1 Laminboard",
            "W8.1.2 Veneer plywood"
        ],
        "W8.2 Particleboard": [
            "W8.2.1 Melamine particleboard",
            "W8.2.2 Veneered particleboard",
            "W8.2.3 Oriented Strand Board(OSB)",
            "W8.2.4 Smooth-surface panel",
            "W8.2.5 Wood cement particleboard",
            "W8.2.6 Plasterboard",
            "W8.2.7 Strawboard",
            "W8.2.8 Graded particleboard",
            "W8.2.1 Melamineparticleboard"
        ],
        "W8.3 Fibreboard": [
            "W8.3.1 High-density fibreboard (HDF)",
            "W8.3.2 Medium-density fibreboard (MDF)",
            "W8.3.3 Softboard",
            "W8.3.4 Medium-hard-fibreboard"
        ]
    },
    "W9 Engineered wood products": {
        "W9.1 Finger jointed wood": [],
        "W9.2 Laminated veneer lumber (LVL)": [],
        "W9.3 Parallel strand lumber (PSL)": [],
        "W9.4 Wood-wool board": [],
        "W9.5 Solid-wood board": [],
        "W9.6 Glued laminated timber (GLULAM)": [],
        "W9.7 I-joists, I-beams": [],
        "W9.8 Laminated compressed wood": [],
        "W9.9 Composite board": [],
        "W9.10 Compressed wood": [],
        "W9.11 Wood-plastic composites": []
    }
};

const level1 = Object.keys(mapping);

const fscOutputClaim = [
    {
        id: "FSC 100%",
        label: "FSC 100%",
        value: "FSC 100%",
    },
    {
        id: "FSC Mix",
        label: "FSC Mix",
        value: "FSC Mix",
    },
    {
        id: "FSC Recycled",
        label: "FSC Recycled",
        value: "FSC Recycled",
    },
    {
        id: "FSC Controlled Wood",
        label: "FSC Controlled Wood",
        value: "FSC Controlled Wood",
    }
]

const primaryActivity = [
    "Brokers/Traders with physical possession",
    "Brokers/Traders without physical possession",
    "Distributor/Wholesaler",
    "Gathering of non-wood products",
    "Logging",
    "Primary Processor",
    "Printing and related service",
    "Publishing activities",
    "Retailers",
    "Secondary Processor"
];

const secondaryActivity = [
    "Brokers/Traders without physical possession",
    "Brokers/Traders with physical possession",
    "Distributor/Wholesaler",
    "Gathering of non-wood products",
    "Logging",
    "Primary Processor",
    "Printing and related service",
    "Publishing activities",
    "Retailers",
    "Secondary Processor"
]

export const getLevel2Options = (level1: keyof typeof mapping) => {
    const level2 = Object.keys(mapping[level1] || {});
    return level2.length ? level2 : [];
}

export function getLevel3Options<T extends keyof typeof mapping>(level1: T, level2: keyof typeof mapping[T]) {
    const level2Mapping = Object.keys(mapping[level1] || {})
    if (!level2Mapping.length) return [];
    return mapping[level1][level2] || [];
}

export const getOptions = (data: string[]) => data.map((item, index) => ({
    id: index,
    label: item,
    value: item
}));

export const optionsData = {
    productCodeL1: [...[{
        id: "--None",
        label: "--None--",
        value: "--None--",
    }],...getOptions(level1)],
    fscOutputClaim: fscOutputClaim,
    primaryActivity: [...[{
        id: "--None",
        label: "--None--",
        value: "--None--",
    }], ...getOptions(primaryActivity)],
    secondaryActivity: [...[{
        id: "--None",
        label: "--None--",
        value: "--None--",
    }],...getOptions(secondaryActivity)],
}